import React from 'react';
import { getRouteApi } from '@tanstack/react-router';
import Sidebar from '../../components/Sidebar/Sidebar';
import Feedbacks from '../../components/Feedbacks/Feedbacks';
import NotificationBell from '../../components/NotificationBell/NotificationBell';
import SystemAdminBadge from '../../components/SystemAdminBadge/SystemAdminBadge';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import { useCurrentUserPermissions } from '../../hooks/useCurrentUserPermissions';
import styles from './FeedbacksPage.module.scss';

const routeApi = getRouteApi('/feedbacks');

const FeedbacksPage: React.FC = () => {
  const { isSystemAdmin } = useCurrentUserPermissions();
  const { ticket } = routeApi.useSearch();

  return (
    <div className={styles.pageLayout}>
      <Sidebar />
      <div className={styles.pageContent}>
        <Feedbacks
          isSystemAdmin={isSystemAdmin}
          initialTicketId={ticket ?? null}
          headerSlot={
            <>
              <LanguageSwitcher />
              {isSystemAdmin ? <SystemAdminBadge /> : <NotificationBell />}
            </>
          }
        />
      </div>
    </div>
  );
};

export default FeedbacksPage;
